import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { ProgressBar } from 'react-bootstrap';
import FileSelector from '../file_selector';
import LoadingSpinner from "components/loading_spinner";
import Records from './records';
import ImportStatus from '../import_status';

import { clickAsLink } from 'helpers/link_helpers';
import { retrieveRunRecords } from '../store/actions/run_records';
import { runImport } from '../store/actions/import_object';

export class Preview extends React.Component {
  static propTypes = {
    creatingRunRecords: PropTypes.bool,
    importPath: PropTypes.string.isRequired,
    importStatus: PropTypes.number.isRequired,
    loadingRecords: PropTypes.bool,
    retrieveRunRecords: PropTypes.func.isRequired,
    onRunImport: PropTypes.func.isRequired
  }

  componentDidMount() {
    const { retrieveRunRecords } = this.props;
    retrieveRunRecords(1);
  }

  handleButtonClick = (e, linkUrl) => {
    clickAsLink(window, linkUrl, e);
  }

  renderPreviewHeader() {
    return (
      <div className="mb-4">
        <h2 className="semi-bold mt-0">Import Preview</h2>
        <div className="larger-text">
          Preview and verify the data from each of your CSVs below.
          This is what your data will look like once imported into Buildout.
          If there are any errors, formatting changes, or other changes you need
          to make to your data, you can edit the individual table cell and make the change.
        </div>
      </div>
    );
  }

  renderButtons() {
    const { importPath, onRunImport } = this.props;

    return (
      <div>
        <div className="btn btn-md btn-cancel" onClick={e => this.handleButtonClick(e, `${importPath}?step=upload`)}>
          &lt; Back
        </div>
        <div className="btn btn-md btn-create ml-4" onClick={onRunImport}>
          Run Import
        </div>
      </div>
    );
  }

  renderProgressBar() {
    const { importStatus } = this.props;

    return (
      <div className="panel panel-default">
        <div className="p-5">
          <div className="h2 semibold mt-0">Preparing Import Preview</div>
          <div className="larger-text mb-4">
            The system is processing your import preview.
            This page will update when the preview is ready
          </div>
          <ProgressBar label={`${importStatus}%`} now={importStatus}/>
        </div>
        <ImportStatus importStatus={["previewing"]} />
      </div>
    );
  }

  renderPreview() {
    const { loadingRecords } = this.props;

    return (
      <React.Fragment>
        {this.renderPreviewHeader()}
        <FileSelector />
        {loadingRecords ? <LoadingSpinner /> : <Records /> }
        {this.renderButtons()}
      </React.Fragment>
    );
  }

  render() {
    const { creatingRunRecords } = this.props;
    return (
      <div className="container step-container preview">
        {creatingRunRecords ? this.renderProgressBar() : this.renderPreview()}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  creatingRunRecords: state.runRecords.creatingRunRecords,
  loadingRecords: state.runRecords.loadingRecords,
  importStatus: state.ui.importStatus,
  importPath: state.paths.importPath
});

const mapDispatchToProps = {
  retrieveRunRecords,

  onRunImport: runImport
};

export default connect(mapStateToProps, mapDispatchToProps)(Preview);
